var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { toDetail } from '../../../helper/util';
import { EBillType } from '../../../enum/EBillType';
var ShopActivityRecordSubTable = (function (_super) {
    __extends(ShopActivityRecordSubTable, _super);
    function ShopActivityRecordSubTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopActivityRecordSubTable.prototype.toOrderDetail = function (order_type, order_id, other_order_id) {
        if (order_type == 1) {
            toDetail(EBillType.PurOrder, order_id, this);
        }
        else if (order_type == 2) {
            toDetail(EBillType.ShopAfterSales, other_order_id, this);
        }
    };
    ShopActivityRecordSubTable.prototype.pageChange = function (pager) {
        var business_id = this.row && this.row.business_id;
        this.$emit('subTablePageChange', business_id, pager);
    };
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], ShopActivityRecordSubTable.prototype, "tableData", void 0);
    __decorate([
        Prop({
            type: Object
        })
    ], ShopActivityRecordSubTable.prototype, "row", void 0);
    __decorate([
        Prop({
            type: Number
        })
    ], ShopActivityRecordSubTable.prototype, "total", void 0);
    ShopActivityRecordSubTable = __decorate([
        Component
    ], ShopActivityRecordSubTable);
    return ShopActivityRecordSubTable;
}(Vue));
export default ShopActivityRecordSubTable;
